export const DateFormatter = Intl.DateTimeFormat('en-US');
export const DateTimeFormatter = Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
});
